import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PatanjaliData } from "src/app/models/productAuth";
import { ProductAuthService } from "src/app/services/product-auth.service";
import { MessageService } from "primeng/api";

@Component({
  selector: "app-pfhppl",
  templateUrl: "./pfhppl.component.html",
  styleUrls: ["./pfhppl.component.css"],
})
export class PfhpplComponent implements OnInit {
  showDialog: boolean = true;
  response: PatanjaliData = new PatanjaliData();
  qrData: string;
  key: string;
  pForm: FormGroup;
  pFormsubmitted: boolean = false;
  constructor(
    private productAuthService: ProductAuthService,
    private fb: FormBuilder,
    private messageService: MessageService
  ) {
    this.pForm = this.fb.group({
      mobile: [null, Validators.required],
      seqNo: [null, Validators.required],
      key: [null, Validators.required],
      name: [null],
      qrData: [null],
    });
  }

  get pFormDetails() {
    return this.pForm.controls;
  }

  ngOnInit() {
    this.qrData = window.location.href;
    this.pForm.patchValue({ qrData: this.qrData });
  }
  hide() {
    this.showDialog = false;
  }

  onSubmitDetails() {
    this.pFormsubmitted = true;
    if (this.pForm.invalid) {
      return;
    }
    if (!this.pForm.invalid) {
      this.productAuthService.GetPatanjaliData(this.pForm.value).subscribe(
        (response: PatanjaliData) => {
          this.response = response;
          this.showDialog = false;
        },
        (error) => {
          this.messageService.add({
            severity: "error",
            summary: "Oops",
            detail: "Some Error occurred",
          });
        }
      );
    }
  }
}
